import { render } from "./AddSquareIcon.vue?vue&type=template&id=3399134a"
import script from "./AddSquareIcon.vue?vue&type=script&lang=js"
export * from "./AddSquareIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__